import {
    CrossRegionPersistence,
} from "@brightagency/headstart-common";
import * as qs from "query-string";
import {
    KNOWN_WPPOST_FIELDS,
    KNOWN_WPTAXTERM_FIELDS,
    WPPost,
    WPTaxTerm,
    CoordType
} from "../../constants/types";
import { ListingAcf } from "../../constants/types/acf";
import { getListingDistanceFromUser } from "../../utils";
import { authenticatedFetch } from "../api";

export const filterListingsByCost = (listings: WPPost<ListingAcf>[], enableFree: boolean) : WPPost<ListingAcf>[] => {
    const filteredLocations: WPPost<ListingAcf>[] = [];
    for (const listing of listings) {
        if (enableFree) {
            if (listing.acf.meta.cost_of_service == 'free') { 
                filteredLocations.push(listing);
        }
        } else {
            filteredLocations.push(listing);
        }
    }
    return filteredLocations;
}

export const filterListingsByRadius = (listings: WPPost<ListingAcf>[] | undefined, sortingCoords: CoordType | undefined) : WPPost<ListingAcf>[] => {
    const filteredLocations: WPPost<ListingAcf>[] = [];
    if (listings) {
        for (const listing of listings) {
            if (sortingCoords) {
                const distance = getListingDistanceFromUser(listing, sortingCoords);
                if (distance && distance <= 100) {
                    filteredLocations.push(listing);
                }
            } else {
                filteredLocations.push(listing);
            }
        }
    }
    return filteredLocations;
}

export const fetchTaxonomy = async (slug: string): Promise<WPTaxTerm[]> => {
    try {
        const query = qs.stringify({
            _fields: KNOWN_WPTAXTERM_FIELDS.join(","),
            per_page: 100,
        });
        const terms = await authenticatedFetch<WPTaxTerm[]>(`/wp-json/wp/v2/${slug}?${query}`);
        return terms;
    } catch (error) {
        console.error(new Error(`Error fetching taxonomy: ${slug}`));
        return [];
    }
};

export const fetchPostType = async <ACFType>(postTypeSlug: string): Promise<WPPost<ACFType>[]> => {
    const suburb = CrossRegionPersistence.getChosenSuburb()?.regionname;
    let posts: any | undefined;
    
    try {
        if(postTypeSlug == 'local-information' ) {
            const query = qs.stringify({
                order: "asc",
                orderby: "menu_order",
                _fields: KNOWN_WPPOST_FIELDS.join(","),
                per_page: 100,
                parent: suburb,
                posttype: postTypeSlug,
            });
            posts = await authenticatedFetch<WPPost<ACFType>[]>(
                `/wp-json/headstart/v1/fetchcustompostdata?${query}`,
            );
        } else {
            if(postTypeSlug == 'listing' ) {
                const query = qs.stringify({
                    order: "asc",
                    orderby: "menu_order",
                    // _fields: KNOWN_WPPOST_FIELDS.join(","),
                    per_page: 100,
                    parent: suburb,
                    posttype: postTypeSlug,
                });
                posts = await authenticatedFetch<WPPost<ListingAcf>[]>(
                    `/wp-json/headstart/v1/fetchfeatureservices?${query}`,
                );
            } else {
                const query = qs.stringify({
                    order: "asc",
                    orderby: "menu_order",
                    _fields: KNOWN_WPPOST_FIELDS.join(","),
                    per_page: 100,
                });
                posts = await authenticatedFetch<WPPost<ACFType>[]>(
                    `/wp-json/wp/v2/${postTypeSlug}?${query}`,
                );
            }
            
        }
        return posts;
 
    } catch (error) {
        console.error(new Error(`Error fetching post type: ${postTypeSlug}`));
        return [];
    }
};

export const fetchRouteData = <T = unknown>(path: string): Promise<WPPost<T>> => {
    const query = qs.stringify({
        path: path,
        preview: qs.parse(window.location.search).preview,
        _fields: KNOWN_WPPOST_FIELDS.join(","),
    });
    return authenticatedFetch<WPPost<T>>(`/wp-json/headstart/v1/route-data?${query}`);
};

export const fetchservicesInRegion = async <ACFType>(postTypeSlug: string): Promise<WPPost<ACFType>[]> => {
    const suburb = CrossRegionPersistence.getChosenSuburb()?.regionname;
    let posts : WPPost<ACFType>[] | undefined;
    try {
        const query = qs.stringify({
            order: "asc",
            orderby: "menu_order",
            _fields: KNOWN_WPPOST_FIELDS.join(","),
            per_page: 100,
            parent: suburb,
            posttype: postTypeSlug,
        });
        posts = await authenticatedFetch<WPPost<ACFType>[]>(
            `/wp-json/headstart/v1/fetchserviceinregion?${query}`,
        );
        return posts;
    } catch (error) {
        console.error(new Error(`Error fetching post type: ${postTypeSlug}`));
        return [];
    }
};